import { useNavigate } from 'react-router-dom';
import PageViewCounter from '@/components/feature/PageViewCounter';

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="relative bg-background-100 text-foreground-700 border-t border-background-200/60">
      <div className="max-w-4xl mx-auto px-6 md:px-10 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3 text-sm">
          <span>&copy; {new Date().getFullYear()} 1mindlab · 抱樹療癒</span>
          <span className="text-foreground-400">·</span>
          <a
            href="https://instagram.com/1mindlab"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1.5 text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer"
          >
            <i className="ri-instagram-line"></i>
            <span>@1mindlab</span>
          </a>
        </div>
        <div className="flex items-center gap-5 text-xs text-foreground-500">
          <button
            type="button"
            onClick={() => navigate('/about')}
            className="hover:text-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            關於我們
          </button>
          <button
            type="button"
            onClick={() => navigate('/privacy')}
            className="hover:text-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            私隱條款
          </button>
          <button
            type="button"
            onClick={() => navigate('/contact')}
            className="hover:text-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            聯絡我們
          </button>
          <button
            type="button"
            onClick={() => navigate('/terms')}
            className="hover:text-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            使用條款
          </button>
        </div>
      </div>

      <PageViewCounter />
    </footer>
  );
}